import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppBar, Toolbar, IconButton, Button } from '@material-ui/core/'

import { ReactComponent as LogoClubMila } from 'assets/images/main-logo-club-mila.svg'
import { useStyleContext } from 'contexts/StyleContext/useStyleContext'
import { ConfigUtils } from 'utils/config'
import { removeAuthHeader } from 'utils/axios'
import { AdminContext } from 'contexts/AdminContext'
import { ReactComponent as LogoTEA } from 'assets/images/main-logo-tea.svg'
import { ReactComponent as LogoTS } from 'assets/images/main-logo-ts.svg'
import { ReactComponent as LogoLepain } from 'assets/images/main-logo-le-pain.svg'
import { ReactComponent as LogoGE } from 'assets/images/main-logo-ge.svg'
import { ReactComponent as LogoCS } from 'assets/images/main-logo-casa-saenz.svg'
import { ReactComponent as LogoPARU } from 'assets/images/main-logo-paru.svg'
import { ReactComponent as LogoJB } from 'assets/images/main-logo-jb.svg'
import { ReactComponent as LogoRonnie } from 'assets/images/main-logo-ronnie.svg'
import { ReactComponent as LogoVicolo } from 'assets/images/main-logo-vicolo.svg'
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg'
import { ReactComponent as QuestionIcon } from 'assets/icons/question.svg'

import { useStyles } from './styles'

interface HeaderProps {
  showRightButton?: boolean
  hideLogo?: boolean
  showBackButton?: boolean
}

const defaultProps = {
  showRightButton: false,
  hideLogo: false,
  showBackButton: true,
}

const Header: React.FC<HeaderProps> = ({
  showRightButton = false,
  hideLogo = false,
  showBackButton = true,
}) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { admin, setAdmin } = useContext(AdminContext)
  const isLoggedIn = !!admin
  const storeLabel =
    admin?.store?.name ??
    (admin?.stores?.length ? admin.stores.map((s) => s.name).join(', ') : undefined)

  const [logoUrl, setLogoUrl] = useState('')

  const { style, getFromStorage, isLoadingStyle } = useStyleContext()

  useEffect(() => {
    const applyLogo = async () => {
      if (style) {
        setLogoUrl(style.storeLogoUrl)
      } else {
        const styleUpdate = await getFromStorage()
        if (styleUpdate) setLogoUrl(styleUpdate.storeLogoUrl)
      }
    }
    applyLogo()
  }, [getFromStorage, isLoadingStyle, style])

  const logos: Record<string, JSX.Element> = {
    cs: <LogoCS height={50} width={400} className={classes.logo} />,
    tea: <LogoTEA height={50} width={400} className={classes.logo} />,
    ge: <LogoGE height={50} width={400} className={classes.logo} />,
    'le-pain-quotidien': <LogoLepain height={50} width={400} className={classes.logo} />,
    paru: <LogoPARU height={50} width={220} className={classes.logo} />,
    jb: <LogoJB height={225} width={225} className={classes.logo} />,
    ts: <LogoTS height={225} width={225} className={classes.logo} />,
    ronnie: <LogoRonnie height={225} width={225} className={classes.logo} />,
    cm: <LogoClubMila height={350} width={350} className={classes.logo} />,
    vicolo: <LogoVicolo height={350} width={350} className={classes.logo} />,
  }

  const defaultLogo = () => {
    const appName = ConfigUtils.getAppName()
    console.log('appName', appName)
    return logos[appName] || null
  }

  console.log('REACT_APP_NAME', process.env.REACT_APP_NAME)

  const onLogout = () => {
    localStorage.clear()
    removeAuthHeader()
    setAdmin(undefined)
    navigate('/login')
  }

  // TODO: ocultar en resolucion de tablet y mobile
  return (
    <>
      <AppBar
        className={isLoggedIn ? `${classes.appBar} ${classes.appBarLoggedIn}` : classes.appBar}
        elevation={0}
        position="absolute"
      >
        <Toolbar className={classes.toolbar}>
          <div className={classes.leftArea}>
            {showBackButton && (
              <IconButton color="primary" className={classes.backButton}>
                <ArrowBackIcon
                  onClick={() => navigate(-1)}
                  width={30}
                  height={30}
                  className={classes.backIcon}
                />
              </IconButton>
            )}

            {isLoggedIn && admin && storeLabel && (
              <Button color="primary" className={classes.storeName}>
                {storeLabel}
              </Button>
            )}
          </div>

          {!hideLogo && (
            <div
              className={
                isLoggedIn ? `${classes.logoArea} ${classes.logoAreaLoggedIn}` : classes.logoArea
              }
            >
              {logoUrl ? (
                <div className={classes.logoContainer}>
                  <img src={logoUrl} alt="Logo" className={classes.logo} />
                </div>
              ) : (
                defaultLogo()
              )}
            </div>
          )}

          <div className={classes.rightArea}>
            {showRightButton ?? (
              <IconButton color="primary">
                <QuestionIcon width={30} height={30} className={classes.questionIcon} />
              </IconButton>
            )}
            {isLoggedIn && (
              <Button color="primary" className={classes.logout} onClick={onLogout}>
                Cerrar sesión
              </Button>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </>
  )
}

Header.defaultProps = defaultProps

export { Header }
